// Angular imports
import { Component } from '@angular/core';

// Import loader service
import { LoaderService } from '../loader.service';
import { Store, select } from '@ngrx/store';
import { CalculationState } from 'src/app/state-management/calculation-state';
import { selectLoadingStatus } from 'src/app/state-management/calculation-selectors';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { AppState } from 'src/app/state-management/app-state';

@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
    private unsubscribe$ = new Subject<void>();
    private loadingStatus$: Observable<boolean>;

    // Boolean to track loader visibility
    public _loaderVisible = false;

    constructor(
        private store: Store<AppState>) {
        this.loadingStatus$ = this.store.pipe(
            takeUntil(this.unsubscribe$),
            select(selectLoadingStatus))
        // this.loaderService._requestLoaderShow.subscribe(() => {
        //     // Make sure loader isn't already visible
        //     if (this._loaderVisible){
        //         return;
        //     }

        //     // Set loader to visible
        //     this._loaderVisible = true;
        // });

        // this.loaderService._requestLoaderHide.subscribe(() => {
        //     // Make sure loader isn't currently visible
        //     if (!this._loaderVisible){
        //         return;
        //     }

        //     // Set loader to not visible
        //     this._loaderVisible = false;
        // });

        this.loadingStatus$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(loading => this._loaderVisible = loading);
    }

    destructor(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
